import { signalStore, withHooks, withState } from '@ngrx/signals';
import { effect, inject } from '@angular/core';
import { BaseState, withCrudOperations } from '../crud.state';
import { Topic } from '../../models/topic';
import { withTopicSelectors } from './topic.selectors';
import { TopicService } from '../../services/topic/topic.service';
import { withLogging } from '../features/logger.feature';
import { withWorkspaceHelpers } from '../workspace-helper.selectors';
import { ActiveUserStore } from '../user/active-user.state';

export type TopicState = BaseState<Topic>;

export const initialState: TopicState = {
  items: {},
  loading: false,
  selectedId: '',
  selection: [],
  initialized: false,
  itemsLoaded: false,
  version: 0,
  lastPersistedId: '',
  trigger: undefined,
  entityType: 'Topic',
  entityLabel: 'Thema',
  filter: {
    query: '',
    category: [],
    tags: undefined,
    products: undefined,
    published: null,
    locked: null,
    ids: undefined,
  },
};

export const TopicStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withCrudOperations<Topic>(TopicService),
  withLogging(initialState.entityType),
  withTopicSelectors(),
  withWorkspaceHelpers(),
  withHooks({
    onInit(store, activeUserStore = inject(ActiveUserStore)) {
      // This store is reachable very early, before any commune is known:
      // the always-mounted ToolOverlayComponent injects RoutingService,
      // whose constructor injects TopicHelperService, which field-injects
      // this store directly. Watch for commune to become available (or
      // change) instead of firing once at construction time.
      effect(
        () => {
          if (activeUserStore.commune()) {
            store.loadAllItemsByPromise();
          }
        },
        { allowSignalWrites: true }
      );
    },
    onDestroy() {
      console.log('on destroy');
    },
  })
);
